// extracted by mini-css-extract-plugin
module.exports = {"container":"Promotion_container__2md3S","brand":"Promotion_brand__r6U2w","circle":"Promotion_circle__113CF","section":"Promotion_section__1LAjD"};